<template lang="pug">
.d-flex.align-center.gap-24
  the-logotype.ui-body-2.weight-600.gap-6(
    :size="40"
  )
  template(v-for="(item, index) in navigationItemsDistributed.links")
    router-link.ui-h3.fit-content-width.text-center(
      :key="index"
      :to="item.to"
      exact-active-class="ui-primary--text"
    ) {{ item.name }}
  v-spacer
  template(v-for="(item, index) in navigationItemsDistributed.buttons")
    dv-menu
      template(#activator="{ attrs, on }")
        dv-btn(
          color="ui-primary"
          v-bind="attrs"
          v-on="on"
        )
          v-icon.mr-2(v-if="item.icon" :size="20") {{ item.icon }}
          p.ui-body-1 {{ item.name }}
      v-list.ui-body-1.pb-0
        v-list-item(
          v-for="(child, childIdx) in item.children"
          :key="childIdx"
          :to="child.to"
          color="ui-primary"
        )
          v-icon(v-if="child.icon" :size="20") {{ child.icon }}
          p.ml-4 {{ child.text }}

</template>

<script>
import TheLogotype from '@/components/layout/Remaked/TheLogotype.vue';
import mixinNavigation from '@/components/layout/Remaked/mixinNavigation';
import { flattenArray } from '@/helpers/array';
import DvMenu from '@/packages/ui/components/menus/DvMenu.vue';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export default {
  components: {
    TheLogotype,
    DvMenu,
    DvBtn,
  },
  props: {},
  mixins: [mixinNavigation],
  computed: {
    navigationItems() {
      if (!this.$user.isAuthenticated) {
        return [];
      }

      // const routes = flattenArray(this.$user.roles.map((role) => this.navigation[role.name])).map((navItem) => ({
      //   ...navItem,
      //   children:
      //     navItem.meta.children &&
      //     navItem.meta.children.filter(
      //       ({ vchtWhitelisted, visibleFor, accessFor, accessArgs }) =>
      //         (
      //           !vchtWhitelisted
      //           && this.$user.hasRoles(visibleFor)
      //           && (!this.$user.isEventManager || !accessFor?.length || this.$user.hasPermissions(accessFor, ...(accessArgs || [])))
      //         )
      //         || (vchtWhitelisted && this.$user.isVchtAllowedOrganization),
      //     ),
      // })).filter(({ meta, children }) => !meta.visibleIfChildren || children?.length);
      return flattenArray(this.navigationOrganization).map(({ name, meta }) => ({
        to: { name },
        icon: meta.icon,
        name: meta.buttonTitle || meta.title,
        button: meta.button || false,
        children: meta.children || [],
      }));
    },
    navigationItemsDistributed() {
      const { navigationItems } = this;
      return {
        links: navigationItems.filter((item) => !item.button && !item.children.length),
        buttons: navigationItems.filter((item) => item.button && item.children.length),
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
